import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApiService } from '@services/rest-api/rest-api.service';
import { PersonalDataAgreement, PersonalDataAgreementSave, PersonalDataAgreementSign } from '@shared/interfaces';
import { API_PATH } from '@shared/tokens';
import { Maybe } from '@shared/types';

@Injectable({
  providedIn: 'root',
})
export class PersonalDataAgreementService {
  constructor(
    @Inject(API_PATH) private readonly apiPath: string,
    private http: RestApiService,
  ) {}

  /** `null` — no agreement text is configured for the user's language. */
  getPersonalDataAgreement(): Observable<Maybe<PersonalDataAgreement[]>> {
    return this.http.get<Maybe<PersonalDataAgreement[]>>(this.apiPath + '/users/personal-data-agreement');
  }

  savePersonalDataAgreement(key: string): Observable<void> {
    const params: PersonalDataAgreementSave = {
      key: key,
    };

    return this.http.put<void, PersonalDataAgreementSave>(`${this.apiPath}/users/personal-data-agreement`, params);
  }

  signPersonalDataAgreement(agreementKey: string, isSigned: boolean): Observable<void> {
    const params: PersonalDataAgreementSign = {
      AgreementKey: agreementKey,
      IsSigned: isSigned,
    };

    return this.http.put<void, PersonalDataAgreementSign>(`${this.apiPath}/users/personal-data-agreement/sign`, params);
  }
}
